export default Object.freeze({
  Light: 300,
  Regular: 500,
  Bold: 700,
});
